import {
  Shield, Thermometer, Ruler, Move, Layers, Wind, Droplet, Snowflake,
  BadgeCheck, Eye, Footprints, Feather, Sparkles,
} from "lucide-react";

const MAP = {
  shield: Shield, thermometer: Thermometer, ruler: Ruler, move: Move,
  layers: Layers, wind: Wind, droplet: Droplet, snowflake: Snowflake,
  "badge-check": BadgeCheck, eye: Eye, footprints: Footprints, feather: Feather,
};

export const SpecIcon = ({ name, className }) => {
  const Cmp = MAP[name] || Sparkles;
  return <Cmp className={className} />;
};

export const formatPrice = (n) => `₺${Number(n).toLocaleString("tr-TR")}`;
